import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
const openAnimate = keyframes`
  0% {
    transform: translate(0, -400px);
  }

  100% {
    transform: translate(0, 0);
  }
`

export const OrderDetailsContent = styled.div<{hasMerchantImage: boolean}>`
  background-color: rgba(40,42,48,0.24);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: ${({ hasMerchantImage }) => hasMerchantImage ? '160px' : '72px'};
  z-index: 5000;
  overflow: hidden;
`

export const DetailsContent = styled.div`
  ${({ theme })=>`
    background-color: ${theme.colors.neutrals.w};
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    overflow: hidden;
  `}
  animation-name: ${openAnimate};
  animation-iteration-count: 1;
  animation-duration: 0.8s;
  animation-timing-function: linear;
  padding: 0 16px;
`

export const ExplainContent = styled.div<{hasProducts: boolean}>`
  ${({ theme })=>`
    padding: 16px 0;
    border-bottom: 1px solid ${theme.colors.grey[2]};
  `}

  ${({ hasProducts }) => !hasProducts && 'border-bottom: none;'};
`

export const Title = styled.p`
  ${({ theme }) => css(theme.typographys.base.bold)};
  color: ${({ theme }) => theme.colors.neutrals.b};
  margin-bottom: 4px;
`

export const Explain = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`


export const ArtList = styled.div`
  display: grid;
  gap: 32px;
  padding: 16px 0;
  max-height: 240px;
  overflow-y: auto;
`
